import { NetworkStatus } from '@cbridge-utils/network';
import { ClpConnectionState } from '@cbridge-packages/api-clp';
import { ILpSymbolKey, ISymbolQuotesStore } from './symbolQuotes.interface';

export const symbolQuotesInitialState: ISymbolQuotesStore = {
  connectionState: ClpConnectionState.Idle,
  clientQuotes: {},
  lpQuotes: {},
  serverSymbols: {
    items: [],
    total: 0,
    networkStatus: NetworkStatus.None,
  },
  lpSymbols: {
    items: [],
    total: 0,
    networkStatus: NetworkStatus.None,
  },
};

export const clientQuoteKey = (symbol: string): string => symbol;

export const lpQuoteKey = ({ lpId, coreSymbolId }: ILpSymbolKey): string => `${lpId}:${coreSymbolId}`;
